import { render, staticRenderFns } from "./MonitoringFiles.vue?vue&type=template&id=248d50a2&scoped=true&lang=pug"
import script from "./MonitoringFiles.vue?vue&type=script&lang=js"
export * from "./MonitoringFiles.vue?vue&type=script&lang=js"
import style0 from "./MonitoringFiles.vue?vue&type=style&index=0&id=248d50a2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248d50a2",
  null
  
)

export default component.exports